import { apiFetch } from "../../../toolympus/api/core";
import { generateCode } from "../../../toolympus/api/data";
import { useEditItem2 } from "../../../toolympus/api/useNewItem";
import { exportRecordsToXlsxSheet } from "../../../toolympus/api/xlsx";
import { createSelectSchema, FieldType, Schema } from "../../../toolympus/hooks/useSchema";
import { useSmartList } from "../../../toolympus/hooks/useSmartList";

export interface EventDiscountCode {
  _id: number;
  event_id?: number;
  applied_to_registration_id?: number;
  
  discount_amount?: number;
  code: string;
}

interface CodesBatch {
  mode: string;
  codes: string;
  template: string;
  discount_amount: number;
  count: number;
}

export const CodesBatchSchema: Schema = {
  mode: createSelectSchema([
    { value: "auto", label: "Auto" },
    { value: "manual", label: "Manual" },
  ], { label: "Mode" }),
  template: { label: "Template", hint: "you may surround the {CODE} part with any text" },
  codes: { label: "Codes", hint: "enter a new code on every line", type: FieldType.textlong },
  discount_amount: { label: "Discount", type: FieldType.number },
  count: { label: "Number of codes to create", type: FieldType.number },
}

export const EventDiscountCodeSchema: Schema = {
  _id: { label: "E-mail" },
  event_id: { label: "Event" },
  applied_to_registration_id: { label: "Applied to", type: FieldType.number },
  
  discount_amount: { label: "Discount", type: FieldType.number },
  code: { label: "Code" },

  created_at: { label: "Created", type: FieldType.datetime },
  created_by: { label: "Created by", type: FieldType.dictionarySelect, dictionary: "Users" },
}

// kind: admin / coorg
export const useEventDiscountCodes = (kind: string, eventId: number) => {
  const apiPathBase = kind === "coorg"
  ? `/api/calendar/${kind}/${eventId}/discount-code`
  : `/api/registration/${kind}/event/${eventId}/discount-code`;

  const codes = useSmartList<EventDiscountCode>(apiPathBase, {
    noLimit: true,
    noView: true,
    schema: EventDiscountCodeSchema,
    newRecordDefault: { code: "", discount_amount: 0 },
    getRecordApiPath: r => `${apiPathBase}/${r._id}`,
    noLoad: !eventId || eventId <= 0,
    textFilterFn: r => `${r.code}`,
  });

  const batchCreate = useEditItem2<CodesBatch>({
    save: async (item) => {

      let newCodes: string[] = [];
      if(item.mode === "manual") {
        newCodes = item.codes.split("\n").map(s => s.trim()).filter(x => !!x);
      } else {
        newCodes = Array.from({ length: item.count })
          .fill(0)
          .map(() => item.template.replace("{CODE}", generateCode()));
      }
      for (const code of newCodes) {
        await apiFetch(`${apiPathBase}`, "post", {
          code,
          discount_amount: item.discount_amount,
        })        
      }

      codes.reload();
      return item;
    }
  })

  const exportRecords = () => {
    exportRecordsToXlsxSheet({
      sheetTitle: "Discount Codes",
      schema: EventDiscountCodeSchema,
      filename: `discountcodes.xlsx`,
      columns: [
        "code",
        "discount_amount",
        "applied_to_registration_id",
        
        "created_at",
      ],
    }, codes.data);
  }

  return {
    ...codes,
    schema: EventDiscountCodeSchema,
    batchCreate,
    batchSchema: CodesBatchSchema,
    exportRecords,
  }
}
